import { render, staticRenderFns } from "./CallcentreQueueCreate.vue?vue&type=template&id=356df3af&"
import script from "./CallcentreQueueCreate.vue?vue&type=script&lang=js&"
export * from "./CallcentreQueueCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports